import { logger as r, EventTypes as i } from "../../shared-lib/index.js";
import t from "../common/event-logger.js";
import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
export function logFeatureFlagImpression(o) {
  if (!e.X()) return;
  if (!o) return !1;
  const n =
      "Not logging a feature flag impression. The feature flag was not part of any matching experiment.",
    s = ir.rr().Fi();
  if (!s[o]) return r.info(n), !1;
  const a = s[o].trackingString;
  if (!a) return r.info(n), !1;
  const f = ir.rr().pi();
  if (f[a])
    return (
      r.info(
        "Not logging another feature flag impression. This ID was already logged this session.",
      ),
      !1
    );
  (f[a] = !0), ir.rr().ji(f);
  const g = { fid: o, fts: a };
  return t.q(i.Fr, g).L;
}
